import { ProductGridCard } from '@/components/products/cards/ProductGridCard/ProductGridCard'

export default function TabArchiveProduct({
    productIds,
}: {
    productIds: string[]
}) {
    return (
        <section className="columns-2 gap-2">
            {/* Show all products in grid */}
            {productIds.map((productId) => (
                <div key={productId} className="mb-2 break-inside-avoid">
                    <ProductGridCard
                        editMode={false}
                        key={productId}
                        productId={productId}
                        onRemove={() => ({})}
                        onClick={() => ({})}
                    />
                </div>
            ))}
        </section>
    )
}
